import React, { useEffect, useState } from "react";
import { Link } from "utils/customLink";
import { getVimeoOembed } from "utils/vimeo";
import DownArrow from "images/icons/down-arrow-dark.inline.svg";
import DownloadIcon from "images/icons/fi-rr-download.inline.svg";
const ParentInfo = ({ parentInfo }) => {
  const parentDetails = parentInfo;
  const [useFeatVid, setFeatVid] = useState();
  const featurevideo = parentDetails.parentVideo;

  useEffect(() => {
    let mounted = true;
    let vimeoId = featurevideo.slice(featurevideo.lastIndexOf("/") + 1);

    if (vimeoId) {
      getVimeoOembed(vimeoId)
        .then((result) => {
          if (mounted) setFeatVid(result);
        })
        .catch((err) => console.error("ParentInfo vimeo error :: ", err));
    }
    return () => (mounted = false);
  }, [featurevideo]);

  return (
    <>
      <h2 className="heading text-left py-5">{parentDetails.introLabel}</h2>
      <div className="divide-y width-divider" />
      <div
        className="dark:gvi-light-gray-text text-black-lighter text-sm pt-5 tab-content_html"
        dangerouslySetInnerHTML={{ __html: parentDetails.introText }}
      />
      {useFeatVid && (
        <div className="py-8">
          <div
            className="w-full"
            dangerouslySetInnerHTML={{ __html: useFeatVid.html }}
          />
        </div>
      )}
      <div
        className="dark:gvi-light-gray-text  text-black-lighter  text-sm pt-5 tab-content_html"
        dangerouslySetInnerHTML={{ __html: parentDetails.parentVideoText }}
      />
      <h3 className="heading text-left py-3">{parentDetails.infoPackLabel}</h3>
      <div
        className="dark:gvi-light-gray-text text-black-lighter  text-sm pt-5 mb-5 tab-content_html"
        dangerouslySetInnerHTML={{ __html: parentDetails.infoPackText }}
      />
      <div className="flex flex-col sm:flex-row">
        <Link
          className="flex items-center justify-center py-2 px-2 text-center w-full sm:w-60 text-mob border border-black-lighter dark:border-white rounded-xxxxl dark:rounded-sm dark:hover:bg-white dark:hover:border-0 dark:hover:!text-black-lighter dark:hover:rounded  hover:border-0 hover:bg-black-lighter !text-black-lighter dark:!text-white hover:!text-white group"
          to={
            parentDetails?.infoPackFile?.mediaItemUrl ??
            `/wp-content/uploads/2020/11/928120249-2020-nov-03-14-13-14-000000-Parent-Pack-2020-Compressed.pdf`
          }
          target={"gvi_blank"}
        >
          Download parent pack
          <div className="flex items-center !pl-4">
            <DownloadIcon className="down-arrow object-contain object-center dark:hidden fill-current " />
            <DownArrow className="down-arrow object-contain object-center hidden dark:block dark:stroke-white dark:group-hover:stroke-black-lighter" />
          </div>
        </Link>
        <Link
          className="flex text-base font-bold underline text-white self-center sm:pt-0 pt-5 sm:pl-10 pl-0"
          to="/parent-info"
        >
          View our Parent Info page
        </Link>
      </div>
    </>
  );
};

export default ParentInfo;
